import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react'

import { Label } from '@/components/ui/label.tsx'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { Blocker } from '@/components/form/Blocker.tsx'
import { DEFAULT_BLOCKER } from '@/constants/DEFAULT_VALUES.ts'
import { TEMPORARY_ID_PREFIX } from '@/constants/PREFIX.ts'

type EditableVersionProps = {
  storyId: string
  value?: Blocker[]
  placeholder: string
}

export const EditableBlockers = ({ storyId, value = [], placeholder }: EditableVersionProps) => {
  return (
    <>
      <Label variant="title">Blockers</Label>
      <div className="flex flex-col gap-1 mt-2 mb-1">
        {value.map((blocker) => (
          <Blocker key={blocker.id} modes={['view', 'edit']} blocker={blocker} placeholder={placeholder} />
        ))}
      </div>
      <Blocker
        modes={['edit']}
        blocker={DEFAULT_BLOCKER(storyId, `${TEMPORARY_ID_PREFIX}${storyId}`)}
        placeholder={placeholder}
      />
    </>
  )
}

export const TypedEditableBlockers = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<Blocker[], undefined, ComponentProps<typeof EditableBlockers>> & RefAttributes<EditableCommands>
>
